<template>
<div class="chapter">
<div class="inner_page">
<h1 class="fm-title" id="fm-4"><a id="page_xvii"><em>Transliterations</em></a></h1><a id="page_xvii">
<p class="fm-head"><strong>Hebrew</strong></p>
<table class="table-l">
<tbody>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">א</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em><span class="char-i">ʾ</span></em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ב</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>b</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ג</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>g</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ד</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>d</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ה</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>h</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ו</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>w</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ז</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>z</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ח</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em><span class="char-i">ḥ</span></em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ט</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em><span class="char-i">ṭ</span></em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">י</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>y</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ך</span> ,<span class="heb">כ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>k</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ל</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>l</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ם</span> ,<span class="heb">מ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>m</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ן</span> ,<span class="heb">נ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>n</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ס</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>s</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ע</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em><span class="char-i">ʿ</span></em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ף</span> ,<span class="heb">פ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>p</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">צ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em><span class="char-i">ṣ</span></em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ק</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>q</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ר</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>r</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">שׂ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>ś</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">שׁ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>š</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ת</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>t</em></p></td>
</tr>
</tbody>
</table>
<p class="para">No distinction is made between the <em>bgdkpt</em> with or without the dagesh lene.</p>
<p class="para0">Compare: <span class="heb">תּוֹרָה</span> = <em>tôrâ</em></p>
<p class="para0"><span class="heb">הַתּוֹרָה</span> = <em>hattôrâ</em></p>
<p class="para0"><span class="heb">תּוֹרָתוֹ</span> = <em>tôrātô</em></p>
<p class="fm-head"><strong>Vowels</strong></p>
<table class="table-l">
<tbody>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ה ָ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>â</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ָ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>ā</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ַ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>a</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ֲ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>ă</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ֵ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>ē</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">י ֵ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>ê</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ֶ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>e</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ְ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>ĕ</em> (if vocal)</p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ֱ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>ĕ</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ִ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>i</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">י ִ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>î</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">וֹ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>ô</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ֹ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>ō</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ָ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>o</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ֳ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>ŏ</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">וּ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>û</em></p></td>
</tr>
<tr>
<td class="tr">
<p class="t-left"><span class="heb">ֻ</span></p></td>
<td class="tr">
<p class="t-left">=</p></td>
<td class="tr2">
<p class="t-left"><em>u</em></p></td>
</tr>
</tbody>
</table>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 009_Transliterations.vue?6bf32e4d